import React from 'react'
import CustomModal from 'components/CustomModal/CustomModal'
import OptionsModalOption from './components/OptionsModalOption'
import useCheckIsMobileScreen from '../../hooks/checkMobileScreen'

const INTEGRATIONS = [
  {
    icon: 'cog.svg',
    title: 'API',
    description: 'Upload via the tiiny API',
    href: 'https://api-docs.tiiny.host'
  },
  {
    icon: 'openai.svg',
    title: 'ChatGPT',
    description: 'Build apps & websites',
    href: 'https://chatgpt.com/g/g-6731c3a9f8a48190b445f7d2c8d4f817-app-website-generator-by-tiinyhost'
  },
  {
    icon: 'chrome.svg',
    title: 'Google Chrome',
    description: 'Upload from your browser',
    href: 'https://chromewebstore.google.com/detail/tiny-host/meippdeigckopliglcajepbiaoaccflc'
  },
  {
    icon: 'n8n.png',
    title: 'n8n',
    description: 'Upload via automations',
    href: 'https://n8n.io/integrations/tiiny-host/'
  },
  {
    icon: 'vs-code.png',
    title: 'VS Code',
    description: 'Upload from your IDE',
    href: 'https://marketplace.visualstudio.com/items?itemName=TiinyHost.tiinyhost'
  },
  {
    icon: 'zapier.png',
    title: 'Zapier',
    description: 'Upload via automations',
    href: 'https://zapier.com/apps/tiiny-host/integrations'
  },
  {
    icon: 'make-logo.png',
    title: 'Make',
    description: 'Upload via automations',
    href: 'https://www.make.com/en/integrations/tiiny'
  },
  {
    icon: 'claude.webp',
    title: 'Claude',
    description: 'Upload via Claude Connector',
    href: 'https://helpdesk.tiiny.host/en/article/how-to-connect-tiiny-host-to-claude-with-mcp-14z1okp/'
  }
]

const IntegrationsModal = ({ show, onClose }) => {
  const { isMobile } = useCheckIsMobileScreen()
  const integrations = INTEGRATIONS

  return (
    <CustomModal
      show={show}
      onHide={onClose}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      size="md"
      className="success_modal"
      enforceFocus={false}
    >
      <div>
        <div className="bg-white rounded px-2 py-4">
          <h1 className="text-center h3 fw-bold mb-3">Integrations</h1>
          <div className="d-flex flex-column mx-3 mt-3">
            {integrations.map((integration, index) => (
              <OptionsModalOption
                key={index}
                icon={`/assets/icons/${integration.icon}`}
                title={integration.title}
                description={integration.description}
                onClick={() => window.open(integration.href, '_blank')}
                rowHeight={isMobile ? '64px' : '100px'}
                iconSize={isMobile ? 28 : 40}
              />
            ))}
          </div>
        </div>
      </div>
    </CustomModal>
  )
}

export default IntegrationsModal
